import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import RetornoCancelamento1 from '../imagens/LancRetornoCancelamento/RetornoCancelamento1.png';

export default class LancRetornoCancelamento extends Component {

    render() {

        const { isOpen, onClose } = this.props;

        return (
            <Modal
                title="Como utilizar o Lançamento Estorno/Cancelamento de Vendas"
                className="modal"
                visible={isOpen}
                destroyOnClose
                onCancel={onClose}
                footer={null}
                width="50%"
                style={{ top: 10 }}
            >
                <Row>
                    <Col xs={24}>
                        <p>Para acessar o Lançamento Estorno/Cancelamento de Vendas:  </p>

                        <div className="image-wrapper">
                            <img className="img_smaller" src={RetornoCancelamento1} alt="Estorno/Cancelamento 1"/>
                        </div>

                        <div className="gray_bar"></div>
                     

                        <h3>No Lançamento de Estornos/Cancelamentos nós temos:</h3>
                        <ol>
                            <li></li>
                        </ol>

                    </Col>
                </Row>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/tutoriais/LancRetornoCancelamento.js